import type { ServerColDef } from '@cmg/data-grid';
import { OnPlatformCellRenderer } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const isOnPlatformColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'isOnPlatform',
  headerName: 'XC',
  initialWidth: 88,
  sortable: false,
  filter: false,
  cellRenderer: OnPlatformCellRenderer,
  cellStyle: {
    display: 'flex',
    alignItems: 'center',
  },
};
